import styled from 'styled-components';

export const ViewMore = styled.a`
  font-size: 16px;
  display: flex;
  align-items: center;
  font-weight: 500;

  .label {
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`;
